import React, { Fragment, useState, useEffect } from 'react';
import { connect } from "react-redux";
import { setAppCustomTitle } from "../../reducers/ThemeOptions";
import SplitCommon from '../Common/SplitCommon';
import FilesSideBase from "./FilesSideBase";
import FilesMainContent from "./FilesMainContent";
import AddFilesModal from './AddFilesModal';
import requestApiService from '../../services/requestApi.service';
import Common from '../Common';
import { getSessionValue, syncOperation } from '../../Common/Appcommon';
import ImportModel from '../Agents/ImportModel';

const KnowledgeBase = (props) => {
    const [sideBarLoader, setSideBarLoader] = useState(false);
    const [mainLoader, setMainLoader] = useState(false);
    const [isModelOpen, setModelOpen] = useState(false);
    const [curRowId, setCurrentRowId] = useState(0);
    const [knbData, setKNBData] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [curRowIndex, setCurrentRowIndex] = useState(-1);
    const [isEdit,setIsEdit] = useState(false);
    const [knType, setKnType] = useState("");
    const [isImportModal, setIsImportModal] = useState(false);
    const [importBtnLoader, setImportBtnLoader] = useState(false);
    const isSubAccountView = getSessionValue("isSubAccountView");

    const toggleImportModal = (isRefresh = false) => {
        setIsImportModal(!isImportModal);
        if(isRefresh){
            refreshKnowledge();
        }
    }

    const refreshKnowledge = async () => {
        await loadKnowledgeBaseList();
    }

    
    useEffect(async () => {
        await loadKnowledgeBaseList();
        await syncOperation("START_KNOWLEDGE_BASE_SYNC");
    }, []);
    useEffect(async () =>{
    },[isEdit]);

    const getSideBarTitleContent = () => {
        return <div>Knowledge Base</div>;
    };

    const onAddKnowledgeBase = () => {
        setModelOpen(!isModelOpen);
        setIsEdit(false);
    }

    const onKNBChange = (rowData, rowIndex) => {
        setRowData(rowData.row);
        setCurrentRowIndex(rowIndex);
        setCurrentRowId(rowData['id']);
    }

    const loadKnowledgeBaseList = async () => {
        setSideBarLoader(true);
        setMainLoader(true);
        let params = {
            "ENTITY": "AIPROCESSOR",
            "OPERATION": "LOAD_KNB",
        }
        let response = await requestApiService.processServerRequest(params, "WebV2");
        if (response.issuccess) {
            let data = response.data;
            setSideBarLoader(false);
            setMainLoader(false);
            setRowData([]);
            setKNBData([]);
            if(data.length > 0) {
                setRowData(data[0]);
                setCurrentRowId(data[0]['id']);
                setCurrentRowIndex(0);
                setKNBData(data);
            }else{
                setRowData([]);
                setKNBData([]);
            }
        }
    }

    const onAddFileSuccess = async (knb = "") => {
        await loadKnowledgeBaseList();
        setTimeout(() => {
            if (!!knb && knb?.['id'] !== undefined) {
                if(!!knbData && knbData.length > 0){
                    const item = knbData.find(kb => kb.id === knb['id']);
                    setRowData(item);
                    setIsEdit(true);
                }
            }
        }, 100);
        setModelOpen(false);
    }

    const isEditModal = (type = "") =>{
        onAddKnowledgeBase();
        setKnType(type);
        if(Object.keys(rowData).length > 0 && type !== ""){
            setIsEdit(true);
        }
    }

    const handleMainLoader = (idLoad) =>{
        setMainLoader(idLoad);
    }

    return (
        <Fragment>
            <Common
                title="Knowledge Base"
                mainLoader={mainLoader}
                titleContent={
                    getSideBarTitleContent()
                }
                titleBody={<></>}
                mainContent={
                    <Fragment>
                        {isModelOpen && <AddFilesModal currentRowId={curRowId} type={knType} onAddFileSuccess={onAddFileSuccess} isModelOpen={isModelOpen} onAdd={onAddKnowledgeBase} isEdit = {isEdit}  knbData={rowData} knbformData = {knbData}/>}
                        {isImportModal && <ImportModel type={"knowledge"} title={"Import Knowledege"} isModelOpen={isImportModal} toggleModal={toggleImportModal} showButtonLoader={setImportBtnLoader}/>}
                        <FilesMainContent 
                            onFileSuccess={onAddFileSuccess} 
                            showLoading={mainLoader} 
                            handleLoader = {handleMainLoader} 
                            knbData={rowData}  
                            onEdit = {isEditModal}
                            formData = {knbData}
                            onChange = {onKNBChange}
                            toggleImportModal = {toggleImportModal}
                            importBtnLoader = {importBtnLoader}
                        />
                    </Fragment>
                }
                titleKey={"showAgentKnowledgeBase"} 
            />
        </Fragment>
    )
    return (
        <Fragment>
            <SplitCommon mobileViewNeedLeftMenu={true}
                sideBarLoader={sideBarLoader}
                mainLoader={mainLoader}
                title="Knowledge Base"
                sideBarTitleContent={
                    getSideBarTitleContent()
                }
                mainTitleContent={
                    <div></div>
                }
                sideBarContent={
                    <Fragment>
                        <FilesSideBase showLoading={sideBarLoader} curRowId={curRowId} onChange={onKNBChange} knbData={knbData} onAdd={onAddKnowledgeBase} />
                    </Fragment>
                }
                mainContent={
                    <Fragment>
                        {isModelOpen && <AddFilesModal onAddFileSuccess={onAddFileSuccess} isModelOpen={isModelOpen} onAdd={onAddKnowledgeBase} isEdit = {isEdit}  knbData={rowData}/>}
                        <FilesMainContent onFileSuccess={onAddFileSuccess} showLoading={mainLoader} handleLoader = {handleMainLoader} knbData={rowData}  onEdit = {isEditModal}/>
                    </Fragment>
                }
                titleKey={"kb_allowed"}  
            />
        </Fragment>
    )
}

const mapStateToProps = (state) => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle,
});

const mapDispatchToProps = (dispatch) => ({
    setAppCustomTitle: (title) => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(KnowledgeBase);